module.exports = __webpack_public_path__ + "img/XianJiaotongUniversity.a992db48.png";